import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {withAttrs} from "../common/utils.js";
import EditableComponent from "./editable-component.js";
import {Title} from "./typo.js";
import Img from "./image.js";
import Stack from "./stack.js";
import {fontFamily, media, shadow} from "./theme.js";
import Collapse from "./collapse.js";
import Doc from "./doc.js";
import PageContact from "./page-contact.js";
export default function HelpPage(props) {
  const {
    headline,
    image,
    sections,
    _uid,
    _editable,
    component,
    contact,
    ...rest
  } = props;
  return /* @__PURE__ */ React.createElement(EditableComponent, {
    ...props
  }, /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(Headline, null, headline), /* @__PURE__ */ React.createElement(Image, {
    ...image
  })), /* @__PURE__ */ React.createElement(Main, null, /* @__PURE__ */ React.createElement(QuestionSections, {
    sections
  }), /* @__PURE__ */ React.createElement(PageContact, {
    ...contact[0]
  }))));
}
function QuestionSections(props) {
  const {sections} = props;
  return /* @__PURE__ */ React.createElement(QuestionSectionsContainer, null, /* @__PURE__ */ React.createElement(Sections, null, sections.map((s) => /* @__PURE__ */ React.createElement(Section, {
    key: s._uid,
    ...s
  }))));
}
function Section(props) {
  const {headline, text, questions} = props;
  return /* @__PURE__ */ React.createElement(EditableComponent, {
    ...props
  }, /* @__PURE__ */ React.createElement(SectionContainer, null, /* @__PURE__ */ React.createElement(SectionHeadline, null, headline), text && /* @__PURE__ */ React.createElement(SectionText, {
    ...text
  }), /* @__PURE__ */ React.createElement(Questions, null, questions.map((q) => /* @__PURE__ */ React.createElement(Question, {
    key: q._uid,
    ...q
  })))));
}
function Question(props) {
  const {question, answer} = props;
  return /* @__PURE__ */ React.createElement(EditableComponent, {
    ...props
  }, /* @__PURE__ */ React.createElement(Collapse, {
    header: /* @__PURE__ */ React.createElement(QuestionContainer, null, question)
  }, /* @__PURE__ */ React.createElement(AnswerContainer, {
    ...answer
  })));
}
const Container = styled.div`
  max-width: 870px;
  margin: auto;
  padding-top: 80px;

  ${media.phone} {
    padding-top: 32px;
  }
`;
const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 80px;

  ${media.phone} {
    grid-template-columns: 1fr;
    grid-gap: 50px;
    margin-bottom: 60px;
  }
`;
const Headline = styled(withAttrs(Title, {level: 1}))`
  font-size: 46px;

  ${media.phone} {
    font-size: 30px;
  }
`;
const Image = styled(withAttrs(Img, {sizes: [400]}))`
  max-width: 100%;
`;
const Main = styled(withAttrs(Stack, {spacing: "xxl"}))``;
const Card = styled.div`
  padding: 56px;
  box-shadow: ${shadow.card};
  border-radius: 4px;
  overflow: hidden;
`;
const QuestionSectionsContainer = styled(Card)`
  ${media.phone} {
    padding: 0;
    box-shadow: none;
  }
`;
const Sections = styled(withAttrs(Stack, {spacing: "xxl"}))`
  ${media.phone} {
    --spacing: 40px;
  }
`;
const SectionContainer = styled.div``;
const SectionHeadline = styled(withAttrs(Title, {level: 2}))`
  font-size: 30px;
  margin-bottom: 50px;

  ${media.phone} {
    font-size: 20px;
    margin-bottom: 24px;
  }
`;
const SectionText = styled(Doc)`
  margin-bottom: 50px;

  ${media.phone} {
    margin-bottom: 24px;
  }
`;
const Questions = styled(withAttrs(Stack, {spacing: "l"}))``;
const QuestionContainer = styled.div`
  font-family: ${fontFamily.secondary};
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;

  ${media.phone} {
    font-size: 14px;
    line-height: 22px;
  }
`;
const AnswerContainer = styled(Doc)`
  font-family: ${fontFamily.primary};
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  margin-top: 10px;
  padding-left: 46px;

  ${media.phone} {
    font-size: 14px;
    line-height: 22px;
  }
`;
